import axios from "axios";
export const KycApi = {
  kyc_profile: async ({ id }) => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const token = sessionStorage.getItem("token");
      const userKey = sessionStorage.getItem("user_key");
      if (!apiUrl || !token || !userKey) {
        throw new Error(
          "API URL, token, or user key is not set in environment variables or session storage."
        );
      }

      const response = await axios.get(`${apiUrl}/kyc-profile/${id}`, {
        headers: {
          "Access-Key": process.env.REACT_APP_ACCESS_KEY, // Use environment variable for access key
          Authorization: `Bearer ${token}`, // Use token from session storage
          "User-Key": userKey, // Use user key from session storage
          "Content-Type": "application/json",
        },
      });
      if (response.status !== 200) {
        throw new Error("failed with status: " + response.status);
      }
      if (response.data.error_code !== 200) {
        throw new Error("failed: " + response.data.message);
      }
      // console.log("Login successful:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error during login:", error);
      throw error;
    }
  },
  kyc_status: async ({ status, id }) => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const token = sessionStorage.getItem("token");
      const userKey = sessionStorage.getItem("user_key");
      if (!apiUrl || !token || !userKey) {
        throw new Error(
          "API URL, token, or user key is not set in environment variables or session storage."
        );
      }

      let path = "kyc-profile-reject";
      if (status === "approved") {
        path = "kyc-profile-verify";
      }

      console.log("KYC status update path:", path);
      console.log("KYC status update ID:", id);
      console.log("KYC status update status:", status);

      // 🛡️ Ambil CSRF cookie dulu (wajib jika pakai Sanctum )
      await axios.get(`${apiUrl.replace("/api", "")}/sanctum/csrf-cookie`);
      const response = await axios.put(
        `${apiUrl}/${path}/${id}`,
        {},
        {
          headers: {
            "Access-Key": process.env.REACT_APP_ACCESS_KEY, // Use environment variable for access key
            Authorization: `Bearer ${token}`, // Use token from session storage
            "Admin-Key": process.env.REACT_APP_ADMIN_KEY, // Use environment variable for admin key
            "User-Key": userKey, // Use user key from session storage
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status !== 200) {
        throw new Error(
          "Failed to verify customer with status: " + response.status
        );
      }
      if (response.data.error_code !== 200) {
        throw new Error("Failed to verify customer: " + response.data.message);
      }
      return response.data;
    } catch (error) {
      console.error("Error fetching KYC status:", error);
      throw error;
    }
  },
};
